import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { ShowroomImageBody } from "types/api/showroomImage";

function useShowroomImageApi() {
    const { del, post, put } = useHttpManaged();
    const createShowroomImage = React.useCallback((body: ShowroomImageBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, ShowroomImageBody, ResponseWithId>({
            url: "/showroom-image",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateShowroomImage = React.useCallback((pathParams: PathParamsWithId, body: ShowroomImageBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, ShowroomImageBody, null>({
            url: "/showroom-image/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteShowroomImage = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/showroom-image/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        createShowroomImage,
        updateShowroomImage,
        deleteShowroomImage
    };
}

export default useShowroomImageApi;